module.exports = __webpack_public_path__ + "img/out_office_pc.36715c50.jpg";